import { Box, Typography } from '@mui/material';
import { Identifier } from '@okletsplay/core';
import classNames from 'classnames';
import React, { FC } from 'react';
import { ActionGuard } from 'shared/components/ActionGuard';
import { useStyles } from './MatchPlayerJoinRequestActions.styles';
import { useEntityRepositoryStatus } from 'app/hooks/store';
import { EntityStoreName } from 'app/enums/store';
import { CurrentMatchStoreStatus } from 'modules/matches/store/current-match/enums';

interface ComponentProps {
  userId?: Identifier;
  onAccept?: (id: Identifier) => void;
  onReject?: (id: Identifier) => void;
}

export const MatchPlayerJoinRequestActions: FC<ComponentProps> = ({
  onAccept,
  onReject,
  userId,
}) => {
  const { classes } = useStyles();

  const accepting = useEntityRepositoryStatus({
    [EntityStoreName.CurrentMatch]: CurrentMatchStoreStatus.Accepting,
  });
  const joining = useEntityRepositoryStatus({
    [EntityStoreName.CurrentMatch]: CurrentMatchStoreStatus.Joining,
  });

  const isAcceptInProgress = accepting || joining;

  const declining = useEntityRepositoryStatus({
    [EntityStoreName.CurrentMatch]: CurrentMatchStoreStatus.Declining,
  });

  const isDisabled = isAcceptInProgress || declining;

  if (!userId) return null;

  return (
    <Box className={classes.controls}>
      <ActionGuard>
        <Typography
          className={classNames(classes.control, classes.accept, {
            [classes.disabled]: isDisabled,
          })}
          onClick={() => onAccept?.(userId)}
        >
          {isAcceptInProgress ? 'Accepting...' : 'Accept'}
        </Typography>
      </ActionGuard>
      <ActionGuard>
        <Typography
          className={classNames(classes.control, classes.reject, {
            [classes.disabled]: isDisabled,
          })}
          onClick={() => onReject?.(userId)}
        >
          {declining ? 'Rejecting...' : 'Reject'}
        </Typography>
      </ActionGuard>
    </Box>
  );
};
